import React from "react";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import { Typography } from "@material-ui/core";
import { withNamespaces } from "react-i18next";

const styles = (theme) => ({
  poolDisclaimerCard: {
    display: "flex",
    flexDirection: "column",
    width: "100%",

    borderRadius: "30px",
    padding: "20px",
    marginBottom: "25px",
    [theme.breakpoints.up("sm")]: {
      borderRadius: "30px",
      padding: "32px",

      marginBottom: "50px",
    },

    border: "2px solid " + theme?.colors?.disclaimerCard?.borderColor,
    boxShadow: "1px 1px 16px 6px " + theme?.colors?.disclaimerCard?.boxShadow,
    background: theme?.colors?.disclaimerCard?.backgroundGradient,
    // border: "2px solid " + theme?.colors?.swap?.maxBorder,
    // boxShadow: "1px 1px 16px 6px rgba(57,118,247,0.3)",
    // background:
    //   "linear-gradient(90deg, rgba(51,117,255,0.6) 0%, rgba(75, 112, 204, 0.7) 25%, rgba(75, 112, 204, 0.7) 50%, rgba(75, 112, 204, 0.7) 75%, rgba(51,117,255,0.6) 100%)",
    color: "#fff",
  },
  poolTitle: {
    // color: theme?.colors?.presale?.cardTitle,
    fontSize: "15px",
    fontWeight: "bold",
    lineHeight: "20px",
    marginBottom: "15px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "25px",
      lineHeight: "30px",
      marginBottom: "30px",
    },
  },

  text: {
    // color: theme?.colors?.presale?.cardText,
    fontSize: "14px",
    lineHeight: "15px",
    letterSpacing: "0px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      lineHeight: "24px",
      marginBottom: "8px",
    },
  },
  subText: {
    // color: theme?.colors?.presale?.cardText,
    fontSize: "14px",
    lineHeight: "15px",
    letterSpacing: "0px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      lineHeight: "24px",
      marginBottom: "5px",
    },
  },
  title: {
    // color: theme?.colors?.presale?.cardText,
    fontSize: "14px",
    fontWeight: "bold",
    lineHeight: "15px",
    letterSpacing: "0px",
    [theme.breakpoints.up("sm")]: {
      fontSize: "16px",
      fontWeight: "bold",
      lineHeight: "24px",
    },
  },
});

const DisclaimerCard = ({ classes, poolInfo }) => {
  return (
    <div className={classes.poolDisclaimerCard}>
      <Typography variant="h1" className={classes.poolTitle}>
        Disclaimer
      </Typography>

      <Typography variant="h5" className={classes.title}>
        PLEASE NOTE THAT WE CANNOT ACCEPT USERS FROM THE FOLLOWING COUNTRIES:
      </Typography>
      <ul style={{ marginTop: "8px" }}>
        <li className={classes.subText}>
          <Typography variant="h5" className={classes.subText}>
            Afghanistan, Albania, Bahamas, Barbados, Botswana, Cambodia, Canada,
            Cuba, Ghana, Iran (Islamic Republic of), Iraq, Jamaica, Korea (the
            Democratic People’s Republic of), Libya, Mauritius, Myanmar,
            Nicaragua, Panama, Pakistan, South Sudan, Sudan (North), Syrian Arab
            Republic, The Crimea, Trinidad and Tobago, Uganda, United States of
            America, Vanuatu, Yemen, Zimbabwe;
          </Typography>
        </li>
        <li className={classes.subText}>
          <Typography variant="h5" className={classes.subText}>
            Jurisdictions in which participation or ownership of tokens is
            prohibited by any applicable Law;
          </Typography>
        </li>
        <li className={classes.subText}>
          <Typography variant="h5" className={classes.subText}>
            Jurisdictions which are subject to United States, United Nations, or
            other applicable sanctions or embargoes.
          </Typography>
        </li>
      </ul>

      <Typography variant="h5" className={classes.subText}>
        By interacting with this platform you hereby declare through onchain
        signature, your proficiency in financial matters and intent to partake
        in digital asset transactions, despite their volatility and high risks.
        You also waive any right to hold this platform, its development team, or
        any affiliated organizations responsible for the results of your
        engagement in any token sale activities.
      </Typography>
    </div>
  );
};

export default withNamespaces()(withRouter(withStyles(styles)(DisclaimerCard)));
